import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { get_states, term_add } from "../../../apis/Common";
import { Button } from "semantic-ui-react";
import { handleNavigation } from "../../../Utils/Utils";
import { lessonWeeks } from "./termWeeks";
const AddTerms = () => {
  const [checkValidation, setCheckValidation] = useState(true);
  const [statelist, setStateList] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors,isDirty  },
    reset,
    getValues,
    setValue,
  } = useForm();
  // Fill in the weeks from the dates; it stays editable.
  const fillWeeks = () => {
    const weeks = lessonWeeks(getValues("start_date"), getValues("end_date"));
    if (weeks) setValue("max_week", weeks, { shouldValidate: true });
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  const onSubmit = async (data) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    // const formattedStartDate = formatDate(data.start_date);
    // const formattedEndDate = formatDate(data.end_date);
    const formattedData = {
      ...data,
      end_date: data.end_date || null,
      max_week: Number(data.max_week),
    };
    // if(!checkValidation){
    //     console.log('not valid');
    // }else{
    let result = await term_add(formattedData);
    if (result.status) {
      return navigate("/admin/general-setting/term/all");
    }
    setIsSubmitting(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      const stateList= await get_states();
      setStateList(stateList?.data);
    };
    fetchData();
  }, []);
  return (
    <div className="right-nav" id="dash-event">
      <div className="modal-content">
        <div className="modal-header">
          <div className="col-md-6">
            <h4 className="modal-title">Add Terms</h4>
          </div>
          <div className="col-md-6 text-end">
            <div className="modify-right">
              <Link
                className="edit-btn"
                to={`/admin/general-setting/term/all`}
                onClick={(e) => {
                    handleNavigation(e,isDirty)
                }}
              >
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
        <div className="modal-body">
          <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Year *</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="e.g. 2026"
                    defaultValue={new Date().getFullYear()}
                    {...register("year", { required: true })}
                  />
                {errors.year && errors.year.type === "required" && (
                  <span className="validation-error">This is required</span>
                )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Term Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Term Name"
                    name="name"
                    {...register("name", { required: true })}
                  />
                {errors.name && errors.name.type === "required" && (
                  <span className="validation-error">This is required</span>
                )}
                </div>
              </div>
              <div className="col-md-6">
                  <div className="form-group">
                    <label>State *</label>
                    <select
                      className="form-select form-control"
                      {...register("state", { required: "This is required" })}
                    >
                       {statelist?.length > 0
                        ? [
                            <option value="">Choose State</option>,
                            statelist?.map((elem) => {
                              return (
                                <option value={elem?.id}>
                                  {elem?.name}
                                </option>
                              );
                            }),
                          ]
                        : [
                            <option value="">State not available</option>,
                          ]}
                    </select>
                    {errors.state && (
                      <span className="validation-error">This is required</span>
                    )}
                  </div>
                </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Start Date *</label>
                  <input
                    type="date"
                    className="form-control"
                    max="9999-12-31"
                    {...register("start_date", {
                      required: "This is required",
                      onChange: fillWeeks,
                    })}
                  />
                {errors.start_date && (
                  <span className="validation-error">{errors.start_date.message}</span>
                )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    max="9999-12-31"
                    {...register("end_date", {
                      onChange: fillWeeks,
                      validate: (value) =>
                        !value || value >= getValues("start_date") || "The end date is before the start date.",
                    })}
                  />
                  <small className="d-block text-muted mt-1">
                    The last lesson day. Leave it empty and the term ends after the weeks below.
                  </small>
                {errors.end_date && (
                  <span className="validation-error">{errors.end_date.message}</span>
                )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Weeks *</label>
                  <input
                    type="number"
                    className="form-control"
                    min="1"
                    max="53"
                    {...register("max_week", {
                      required: "This is required",
                      min: { value: 1, message: "At least 1 week." },
                      max: { value: 53, message: "At most 53 weeks." },
                    })}
                  />
                  <small className="d-block text-muted mt-1">
                    Weekly lessons in the term, counted from the dates. Change it if a week is skipped.
                  </small>
                {errors.max_week && (
                  <span className="validation-error">{errors.max_week.message}</span>
                )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Status</label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      {...register("status", { required: true })}
                      id="inlineRadio1"
                      value="1"
                      defaultChecked
                    />
                    <label className="form-check-label" htmlFor="inlineRadio1">
                      Active
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      {...register("status", { required: true })}
                      id="inlineRadio2"
                      value="0"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio2">
                      Inactive
                    </label>
                  </div>
                {errors.status && errors.status.type === "required" && (
                  <span className="validation-error">This is required</span>
                )}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                type="submit"
                className="btn button"
                disabled={isSubmitting}
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export { AddTerms };